import { useNavigate } from "react-router-dom";
import logo from "./../../../assets/images/logo/logo.svg";

import "../../../styles/layouts/header/_headerLogoComponent.scss";

export const HeaderLogoComponent = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="logoContainer" onClick={handleLogoClick}>
      <img src={logo} alt="logo" />
    </div>
  );
};

export default HeaderLogoComponent;
